export enum PhoneType {
    Cell = 'Cell',
    Home = 'Home',
    Work = 'Work',
}

export const phoneTypes: ReadonlyArray<string> = Object.values(PhoneType)